// extracted by mini-css-extract-plugin
export default {"dotcomMessages":"dotcomMessages__2SYDS"};